<template lang="pug">
    div.congratulationWrapper
        canvas#c

        div.overlay

        div.congratulationBody
            h3.text-xs-center Congratulations!

            p.text-xs-center.mt-3.mb-1 You have successfully completed three meditations. We hope you are feeling a little less stressed and a bit more mindful.

            p.text-xs-center.mt-1.mb-4
                | Keep up the great work. We’ll be back again soon to celebrate more of your accomplishments!

            separator-component

            p.text-xs-center
                // I agree button
                button-component.mt-3(
                    :action="closeCongratulationDialog"
                    color="primary"
                    large
                ) {{ $t('general.ok') }}
</template>

<script>
    import Button from '~components/Button';
    import Separator from '~components/Separator';

    export default {
        components: {
            ButtonComponent: Button,
            SeparatorComponent: Separator
        },
        mounted() {
            let H,
                Particle,
                W,
                animate,
                animationLoop,
                canvas,
                colors,
                ctx,
                damping_constant,
                display_list,
                draw,
                init,
                last_time,
                num_particles,
                spring_constant,
                update;

            canvas = null;
            ctx = null;
            num_particles = 800;
            display_list = [];
            last_time = null;
            spring_constant = 0.45;
            damping_constant = 0.4;
            colors = ['#022341', '#022341', '#c0c0c0', '#022341'];
            W = window.innerWidth;
            H = window.innerHeight;
            init = function() {
                let _i, _results;
                canvas = document.getElementById('c');
                ctx = canvas.getContext('2d');
                canvas.width = W;
                canvas.height = H;
                _results = [];
                for (_i = 0; _i < num_particles; _i++) {
                    _results.push(display_list.push(new Particle()));
                }
                return _results;
            };
            animate = function() {
                animationLoop();
                return window.requestAnimationFrame(animate);
            };
            animationLoop = function() {
                let current_time, dt;
                if (!last_time) {
                    last_time = new Date().getTime();
                }
                current_time = new Date().getTime();
                dt = (current_time - last_time) / 500;
                last_time = current_time;
                window.fps = 1 / dt;
                draw();
                return update();
            };
            draw = function() {
                let child, _i, _len, _results;
                ctx.fillStyle = '#ffffff';
                ctx.fillRect(0, 0, W, H);
                _results = [];
                for (_i = 0, _len = display_list.length; _i < _len; _i++) {
                    child = display_list[_i];
                    if (typeof child.draw !== 'function') {
                        continue;
                    }
                    ctx.save();
                    if (!isNaN(child.x || isNaN(child.y))) {
                        ctx.translate(child.x, child.y);
                    }
                    if (!isNaN(child.scale_x || isNaN(child.scale_y))) {
                        ctx.scale(child.scale_x, child.scale_y);
                    }
                    if (!isNaN(child.alpha)) {
                        ctx.globalAlpha = child.alpha;
                    }
                    child.draw();
                    _results.push(ctx.restore());
                }
                return _results;
            };
            update = function() {
                let child, _i, _len, _results;
                _results = [];
                for (_i = 0, _len = display_list.length; _i < _len; _i++) {
                    child = display_list[_i];
                    if (typeof child.update === 'function') {
                        _results.push(child.update());
                    } else {
                        _results.push(void 0);
                    }
                }
                return _results;
            };
            Particle = (function() {
                function Particle(radius, x, y) {
                    this.radius = radius != null ? radius : 1;
                    this.x = x != null ? x : Math.random() * W;
                    this.y = y != null ? y : Math.random() * H;
                    this.speed_x = 10 - Math.random() * 20;
                    this.speed_y = 10 - Math.random() * 20;
                    this.ox = this.x;
                    this.oy = this.y;
                    this.color = '#ff0';
                    this.alpha = 0.9;
                    this.reset();
                }

                Particle.prototype.draw = function() {
                    let x = 1,
                        y = 1,
                        r = 1,
                        n = 4,
                        inset = 4;
                    ctx.fillStyle = this.color;
                    ctx.beginPath();

                    ctx.translate(x, y);
                    ctx.moveTo(0, 0 - r);
                    for (var i = 0; i < n; i++) {
                        ctx.rotate(Math.PI / n);
                        ctx.lineTo(0, 0 - r * inset);
                        ctx.rotate(Math.PI / n);
                        ctx.lineTo(0, 0 - r);
                    }
                    ctx.closePath();
                    return ctx.fill();
                };
                Particle.prototype.update = function() {
                    let acc_x, acc_y;
                    acc_x =
                        -spring_constant * (this.x - this.ox) -
                        damping_constant * this.speed_x;
                    acc_y =
                        -spring_constant * (this.y - this.oy) -
                        damping_constant * this.speed_y;
                    this.speed_x += acc_x;
                    this.speed_y += acc_y;
                    this.alpha -= 0.02;
                    this.scale_x += 0.05;
                    this.scale_y += 0.05;
                    this.x += this.speed_x;
                    this.y += this.speed_y;
                    if (this.alpha <= 0) {
                        return this.reset();
                    }
                };
                Particle.prototype.reset = function() {
                    this.alpha = Math.random();
                    this.scale_x = this.scale_y = Math.random();
                    return (this.color =
                        colors[~~(Math.random() * colors.length)]);
                };
                return Particle;
            })();
            init();
            animate();
        },
        methods: {
            closeCongratulationDialog() {
                window.location.href = '/rate-experience';
            }
        }
    };
</script>

<style lang="stylus" scoped>
    .congratulationWrapper
        height: 100vh
        display: flex
        align-items: center
        justify-content: center
        background-color: #ffffff

        #c
            position: absolute
            height: 100vh
            z-index: 1

        .overlay
            position: absolute
            bottom: 0
            left: 0
            width: 100vw
            height: 35%
            z-index: 5
            background: linear-gradient(360deg, #ffffff 40%, rgba(255, 255, 255, 0) 100%);

        .congratulationBody
            z-index: 10
            padding: 40px
            color: #022341
            background: rgba(255, 255, 255, 0.8)

            h3
                font-size: 27px
</style>
